<template>
    <div>
        <section class="section has-text-centered">
            <div class="card is-white">
                <div class="card column is-white">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column">
                                <img class="ioLogo" src="../assets/images/logos/iotech_logo.png"/>
                            </div>
                            <div class="column has-text-left">
                                <div class="info">
                                    <font-awesome-icon icon="phone"/>
                                    +351 302 002 958 <br></div>
                                <div class="info">
                                    <font-awesome-icon icon="mobile"/>
                                    +351 913 982 653 <br></div>
                                <div class="info">
                                    <font-awesome-icon icon="at"/>
                                    <a href="mailto:geral@iotech.pt" target="_top"> geral@iotech.pt</a> <br></div>
                                <div class="info">
                                    <font-awesome-icon icon="map-marker"/>
                                    Made INcubar - Av. Riopele, 946<br>
                                    4770-405 Pousada de Saramagos<br>
                                    VN. Famalicão, Braga, Portugal
                                </div>
                                <br><br>
                                <font-awesome-icon icon="id-card"/>
                                <a href="../assets/iocard.vcf" download>
                                    Add Contact to Address Book
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section has-text-centered">
            <h1>Social Networks:</h1>
            <div class="columns social has-text-centered">
                <div class="column iotech">
                    <a href="https://iotech.pt" target="_blank"><img src="../assets/images/logos/site.png" width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://instagram.iotech.pt" target="_blank"><img src="../assets/images/logos/instagram.png"
                                                                       width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://facebook.iotech.pt" target="_blank"><img src="../assets/images/logos/facebook.png"
                                                                      width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://youtube.iotech.pt" target="_blank"><img src="../assets/images/logos/youtube.png"
                                                                     width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://twitter.iotech.pt" target="_blank"><img src="../assets/images/logos/twitter.png"
                                                                     width="80"/></a>
                </div>
            </div>
            <div class="columns social has-text-centered">
                <div class="column">
                    <a href="https://linkedin.iotech.pt" target="_blank"><img src="../assets/images/logos/linkedin.png"
                                                                      width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://f6s.iotech.pt" target="_blank"><img src="../assets/images/logos/f6s.png" width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://angel.iotech.pt" target="_blank"><img src="../assets/images/logos/angel.png"
                                                                   width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://crunchbase.iotech.pt" target="_blank"><img src="../assets/images/logos/cb.png" width="80"/></a>
                </div>
                <div class="column">
                    <a href="https://blog.iotech.pt" target="_blank"><img src="../assets/images/logos/blog.png" width="80"/></a>
                </div>
            </div>
            <br>
            <h1>Know our solutions:</h1>
            <a href="https://iostore.iotech.pt" target="_blank"><img class="iostore" src="../assets/images/logos/iostore.png"
                                                             width="80"/></a>
        </section>
    </div>
</template>

<script>

    export default {
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>


    h1 {
        font-size: 30px !important;
        font-weight: bold;
    }

    .title {
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.125;
    }

    .iostore {
        margin-top: 10px;
    }

    h2 {
        font-size: 20px !important;
        font-family: Montserrat, sans-serif !important;
        font-weight: 400;
    }

    .card {
        -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
        background-color: #fff;
        box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
        color: #4a4a4a;
        max-width: 100%;
        position: relative;
    }

    .social {
        padding-top: 10px;
        margin: auto;
        width: 60%;
    }

    /*.modal-content {*/
    /*background: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);*/
    /*margin: auto;*/
    /*padding: 20px;*/
    /*}*/

    .is-white {
        background-image: linear-gradient(120deg,#fdfbfb,#ebedee);
        margin: auto;
        /*max-height: 500px;*/
        width: 800px;
    }


    @media only screen and (min-width: 600px) {
        .ioLogo {
            margin-top: 40px;
            width: 50%;
            height: auto;
            max-width: 100%;
        }
    }
    @media only screen and (max-width: 600px) {
        .ioLogo {
            width: 50%;
            height: auto;
            max-width: 100%;
        }
    }



    .info {
        padding-top: 10px;
    }


</style>
